import React from 'react';
import './AdminPanel.scss';

const AdminPanel = () => {
    return (
        <div>
            AdminPanel
        </div>
    )
}

export default AdminPanel;